import { format, parseISO } from "date-fns";

export default function( date, token = "MMM do, yyyy" ) {
	if ( !date ) {
		return null;
	}

	if ( typeof date === "string" && date.indexOf( "-" ) !== -1 ) {
		date = parseISO( date );
	}

	const formattedDate = format( date, token );

	if ( formattedDate === "Invalid Date" ) {
		return date;
	}

	return formattedDate;
}
